module.exports = __webpack_public_path__ + "assets/img/7_1608_big.67ec91a6.jpg";